import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const fileAiPromptMutations: UpdatesConfig['Mutation'] = {
  fileAiPromptCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('fileAiPrompts', cache);
  },
  fileAiPromptUpdate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('fileAiPrompts', cache);
  },
};

export default fileAiPromptMutations;
